import { createContext, useContext, useState, useCallback, useRef } from 'react';
import HelpGuidePage from '../pages/HelpGuidePage';

const HelpGuideContext = createContext({
  openHelpGuide: () => {},
  closeHelpGuide: () => {},
  registerFaqOpener: () => () => {},
});

export function HelpGuideProvider({ children }) {
  const [open, setOpen] = useState(false);
  const faqOpenerRef = useRef(null);

  const openHelpGuide = useCallback(() => setOpen(true), []);
  const closeHelpGuide = useCallback(() => setOpen(false), []);

  const registerFaqOpener = useCallback((fn) => {
    faqOpenerRef.current = fn;
    return () => {
      if (faqOpenerRef.current === fn) faqOpenerRef.current = null;
    };
  }, []);

  const handleOpenFaq = useCallback(() => {
    faqOpenerRef.current?.();
  }, []);

  return (
    <HelpGuideContext.Provider value={{ openHelpGuide, closeHelpGuide, registerFaqOpener }}>
      {children}
      {open && <HelpGuidePage onClose={closeHelpGuide} onOpenFaq={handleOpenFaq} />}
    </HelpGuideContext.Provider>
  );
}

export function useHelpGuide() {
  return useContext(HelpGuideContext);
}
